// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__1cOYQ","loader":"ContentLoader_loader__2lH_D","disabled":"ContentLoader_disabled__3_NYZ"};